import axios from "axios";

export default {
  namespaced: true,
  state: {
    top10: null
  },
  mutations: {
    setTop10(state, data) {
      state.top10 = data;
    }
  },
  actions: {
    async fetchTop10({ state, commit }) {
      if (state.top10) return state.top10;
      const response = await axios.get("/api/boxscores/leaders/getTop10Players");
      commit("setTop10", response.data);
      return response.data;
    }
  }
}